import type { InviteInfo } from "./types";

type Invite = InviteInfo["invites"][number];

export function inviteResendButtonLabel(invite: Pick<Invite, "status" | "canResendEmail" | "emailResendsRemaining" | "emailNextResendAt">, now = new Date()): string {
  if (invite.status !== "pending") return "Resend";
  if (invite.canResendEmail) return "Resend";
  if (invite.emailResendsRemaining <= 0) return "Resend limit";

  const nextResendAt = parseDate(invite.emailNextResendAt);
  if (!nextResendAt) return "Wait";

  const minutes = Math.max(1, Math.ceil((nextResendAt.getTime() - now.getTime()) / 60000));
  return `Wait ${minutes}m`;
}

export function inviteCanShowResend(invite: Pick<Invite, "status" | "inviteeEmail">): boolean {
  return invite.status === "pending" && Boolean(invite.inviteeEmail);
}

export function inviteCanCancel(invite: Pick<Invite, "status">): boolean {
  return invite.status !== "accepted";
}

function parseDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
